import { defineNuxtRouteMiddleware, navigateTo } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  // Only run on client-side
  if (process.server) return
  
  // Check if we're in development mode
  const isDev = process.env.NODE_ENV === 'development'
  
  // If not in development mode and trying to access a /dev/ page
  if (!isDev && to.path.startsWith('/dev/')) {
    // Redirect to homepage
    return navigateTo('/')
  }
}) 